import Avatar from "../Icons/Avatar";
import Logo from "../Icons/Logo";
import QCRLogoMark from "../Icons/QCRLogoMark";
import AccountIcon from "../Icons/AccountIcon";
import NotificationIcon from "Components/Icons/NotificationIcon";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../Context/Context";
import MiniAvatar from "../Icons/MiniAvatar";
import { ADMIN, PROFESSIONAL, startSubsSession, DOMAIN, CLIENTTAB, profCasesPanelItems, ADMINTAB, ASSISTANTADMINTAB, CLIENT, premiumProfCasesPanelItems, MOBILEADMINTAB, FIRM } from "Constants";
import SearchBox from "./SearchBox";
import HeaderMenuItems from "./HeaderMenuItems";
import MembershipButton from "./MembershipButton";
import SearchContentProf from "./SearchContentProf";
import { IoIosLogOut } from "react-icons/io";
import { signOut } from "aws-amplify/auth";
import AttorneyHeaderMobile from "./AttorneyHeaderMobile";
import useIsMobile from "Hooks/useIsMobile";
import NotificationsDropdown from "Modals/NotificationsDropdown";


const Header = ({noMenu=null, noSearch=null, noSubs=null, showDashboard=null, setUpdateComp, caseList=false}) => {
    const {userDetails, notificationCount} = useContext(Context);
    const {selectedMenuItem, setSelectedMenuItem} = useContext(Context);
    const isMobile = useIsMobile();
    const [notificationColor, setNotificationColor] = useState("text-sky-600");
    const [showNotifDropdown, setShowNotifDropdown] = useState(false);
    const {role} = userDetails ? userDetails : "";
    const navigate = useNavigate();
    useEffect(() => {
        console.log("notificationCount in header", setUpdateComp);
    },[]);
    const unReadNotifications = notificationCount;
       const signoutUser = async () => {
              try {
                  await signOut();
                  localStorage.clear();
                  navigate("/");
              } catch (error) {
                  console.log("error signing out", error);
              }
          }

    useEffect(() => {
        if(userDetails.isAdminAssistant)
        {
          ASSISTANTADMINTAB[0].count = userDetails?.awaits?.validUserIdCount
        }
        else 
        {
          ADMINTAB.find((t) => t.menuName === "approve").count = userDetails?.awaits?.validUserIdCount
        }
        
        if(userDetails?.isUserFunder && userDetails?.isActiveSubscription)
        {
            premiumProfCasesPanelItems[3].menu = "ATTORNEY TEAMUP"
        }
        else if( userDetails?.isActiveSubscription)
        {
            premiumProfCasesPanelItems[3].menu = "FUNDER TEAMUP"
        }
      },[userDetails])
     return <>
        {
            
            userDetails ?
                (role === PROFESSIONAL || role === FIRM ?
                (userDetails?.isUserAssistant ?
                    <div className="col-span-6 sticky top-0 flex w-full z-20 items-center justify-between font-plexsans px-3 lg:px-[30px] py-[14px] min-h-[62px]" style={{background:'#14213d', gap:'24px'}}>
                        <div className="flex items-center" style={{gap:'32px'}}>
                            <Link className="flex items-center cursor-pointer flex-none" style={{gap:'9px'}} to="/attorney/casesFeed/availableCases">
                                <QCRLogoMark size={20} color="#c9a26a"/>
                                <span className="hidden sm:flex items-start gap-1.5">
                                    <span style={{font:"600 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.055em', textTransform:'uppercase', color:'#f7f4ed'}}>Quick Case Review</span>
                                    <span style={{font:"500 7px/1 'IBM Plex Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', color:'#c9a26a', marginTop:'1px'}}>Beta</span>
                                </span>
                            </Link>
                            {showDashboard ?
                                <Link to={"/attorney/casesFeed/availableCases"} className="w-max flex items-center cursor-pointer transition-colors hover:!text-[#f7f4ed]" style={{font:"500 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.03em', color:'rgba(247,244,237,.55)'}}>
                                    Dashboard
                                </Link>
                                :
                            null}
                        </div>

                        <div className="flex justify-end items-center" style={{gap:'16px'}}>
                            <div
                            onClick={() => {
                                setNotificationColor("text-tan");
                                setShowNotifDropdown(true)} }
                            className="cursor-pointer">
                                <NotificationIcon size={17} color="text-[rgba(247,244,237,0.6)] hover:text-[#f7f4ed]" count={unReadNotifications}/>
                            </div>
                            <MiniAvatar size={26}/>
                        </div>
                    </div>
                :
                    (
                    isMobile ?
                    <AttorneyHeaderMobile 
                        caseList={caseList}
                        noSearch={noSearch}
                        noSubs={noSubs}
                        setUpdateComp={setUpdateComp}
                        setSelectedMenuItem={setSelectedMenuItem}
                        notificationColor={notificationColor}
                        unReadNotifications={unReadNotifications}
                        setNotificationColor={setNotificationColor}
                        onBellClick={() => setShowNotifDropdown(true)}
                        
                    />
                    :
                    // Attorney / firm header — Case List design: menu items carry the height
                    // (24px/21px padding + 3px gold underline on the active one) = 62px
                    <div className="col-span-6 sticky top-0 flex items-center justify-between w-full z-30 font-plexsans px-[32px]" style={{background:'#14213d', gap:'24px', minHeight:'62px'}}>
                        <div className="flex items-center flex-1 min-w-0" style={{gap:'44px'}}>
                            <Link className="flex items-center cursor-pointer flex-none" style={{gap:'9px'}} to="/attorney/casesFeed/availableCases">
                                <QCRLogoMark size={19} color="#c9a26a"/>
                                <span className="hidden sm:flex items-start" style={{gap:'4px'}}>
                                    <span style={{font:"600 13px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.05em', textTransform:'uppercase', color:'#f7f4ed', whiteSpace:'nowrap'}}>Quick Case Review</span>
                                    <sup style={{font:"600 8.5px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.1em', color:'#c9a26a', top:0}}>BETA</sup>
                                </span>
                            </Link>
                            {!noMenu ?
                            <HeaderMenuItems
                            showCount={true}
                            dark={true}
                            variant="marketplace"
                            fontSize={1} menuItems={
                                userDetails?.isActiveSubscription ?
                                premiumProfCasesPanelItems
                                :
                                profCasesPanelItems
                            } userInfo={userDetails}/>
                            :
                            (showDashboard ?
                                <Link to={"/attorney/casesFeed/availableCases"} className="w-max flex items-center cursor-pointer transition-colors hover:!text-[#f7f4ed]" style={{font:"600 13.5px/1 'IBM Plex Sans',sans-serif", color:'rgba(247,244,237,.6)', padding:'24px 0 21px', borderBottom:'3px solid transparent'}}>
                                    Dashboard
                                </Link>
                                :
                            <span style={{minHeight:'62px'}} />) }
                        </div>
                        <div className="flex flex-none justify-end items-center" style={{gap:'20px'}}>
                               {!noSearch ?
                                <SearchContentProf size="l" variant="dark"
                                setUpdateComp={setUpdateComp}
                                />
                                : null}
                            <div onClick={() => {
                                setNotificationColor("text-tan");
                                setShowNotifDropdown(true);
                            } }
                                className="cursor-pointer">
                                    <NotificationIcon size={18} color="text-[rgba(247,244,237,0.75)] hover:text-[#f7f4ed]" count={unReadNotifications}/>
                            </div>
                            {!noSubs ? <MembershipButton/> : null}
                            <MiniAvatar size={32}/>
                        </div>
                    </div>
                    )
            )
            :
            role === CLIENT ?
                <div className="col-span-6 sticky top-0 flex w-full z-30 items-center justify-between lg:px-6 px-3 h-[56px] lg:h-[64px] font-plexsans" style={{background:'#14213d'}}>
                    <div className="flex items-center gap-4 lg:gap-8 min-w-0">
                        <Link className="flex items-center gap-2 cursor-pointer flex-none" to="/client/cases">
                            <QCRLogoMark size={20} color="#c9a26a"/>
                            <span className="hidden sm:flex items-start gap-1.5">
                                <span style={{font:"600 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.055em', textTransform:'uppercase', color:'#f7f4ed'}}>Quick Case Review</span>
                                <span style={{font:"500 7px/1 'IBM Plex Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', color:'#c9a26a', marginTop:'1px'}}>Beta</span>
                            </span>
                        </Link>
                        {!noMenu ?
                        <div className="hidden lg:flex items-center gap-5" style={{font:"500 12px/1 'IBM Plex Sans',sans-serif"}}>
                            {CLIENTTAB.map((item) => (
                                <span
                                key={item.key}
                                onClick={() => {setSelectedMenuItem(item.key); navigate(item.link)}}
                                className="cursor-pointer pb-[3px]"
                                style={parseInt(selectedMenuItem) === parseInt(item.key)
                                    ? {color:'#fffdf8', borderBottom:'1.5px solid #c9a26a'}
                                    : {color:'rgba(247,244,237,.55)'}}
                                >{item.menu === "CASES" ? "Cases" : item.menu === "NOTIFICATIONS" ? "Notifications" : item.menu}</span>
                            ))}
                        </div>
                        :
                        (showDashboard ?
                            <Link to={"/client/cases"} className="hidden lg:flex items-center cursor-pointer" style={{font:"500 12px/1 'IBM Plex Sans',sans-serif", color:'rgba(247,244,237,.55)'}}>
                                My Cases
                            </Link>
                            :
                        null) }
                    </div>
                    <div className="flex items-center gap-3 lg:gap-4 flex-none">
                        <div
                        onClick={() => {
                            setNotificationColor("text-ivory"); 
                            setShowNotifDropdown(true)}}
                        className="cursor-pointer flex" to="/notifications">
                             <NotificationIcon size={isMobile ? 19 : null} color={notificationColor === "text-sky-600" ? "text-ivory" : notificationColor} count={unReadNotifications}/>
                        </div>
                        <MiniAvatar/>
                    </div>
                </div>
                :
                role === ADMIN &&
                <div className="col-span-6 sticky top-0 flex w-full z-30 items-center justify-between font-plexsans px-3 lg:px-[26px] py-[13px] min-h-[56px]" style={{background:'#14213d', gap:'24px'}}>
                    {/* phones: the menu takes the space left and scrolls sideways instead of running under the bell/avatar */}
                    <div className="flex items-center min-w-0 gap-[30px] max-lg:flex-1 max-lg:gap-4">
                        <Link className="flex items-center cursor-pointer flex-none" style={{gap:'9px'}} to={userDetails?.isAdminAssistant ? "/admin/approve" : "/admin/outreach"}>
                            <QCRLogoMark size={20} color="#c9a26a"/>
                            <span className="hidden sm:flex items-start gap-1.5">
                                <span style={{font:"600 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.055em', textTransform:'uppercase', color:'#f7f4ed'}}>Quick Case Review</span>
                                <span style={{font:"500 7px/1 'IBM Plex Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', color:'#c9a26a', marginTop:'1px'}}>Admin</span>
                            </span>
                        </Link>
                        <div className="w-max max-lg:w-auto max-lg:min-w-0 max-lg:overflow-x-auto max-lg:[scrollbar-width:none] max-lg:[&::-webkit-scrollbar]:hidden">
                        {!noMenu ?
                        <HeaderMenuItems dark={true} variant="admin" fontSize={2} menuItems={userDetails.isAdminAssistant ? ASSISTANTADMINTAB : (isMobile ? MOBILEADMINTAB : ADMINTAB)}/>
                        :
                        (showDashboard ?
                            <Link to={"/admin/analytics"} className="w-max flex items-center cursor-pointer transition-colors hover:!text-[#f7f4ed]" style={{font:"500 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.04em', color:'rgba(247,244,237,.55)'}}>
                                Dashboard
                            </Link>
                        :
                    null) }
                        </div>
                    </div>
                    <div className="flex flex-none justify-end items-center" style={{gap:'16px'}}>
                        <div
                         onClick={() => {
                            setNotificationColor("text-tan");
                            setShowNotifDropdown(true)} }
                        className="cursor-pointer">
                        <NotificationIcon size={17} count={0} color="text-[rgba(247,244,237,0.6)] hover:text-[#f7f4ed]"/>
                        </div>
                        <MiniAvatar size={26}/>
                    </div>
                </div>)
                :
                <div className="col-span-6 sticky top-0 flex w-full z-30 lg:px-6 px-3 h-[56px] lg:h-[64px] font-plexsans" style={{background:'#14213d'}}>

                    <div className="flex w-full  items-center justify-left">
                        <QCRLogoMark size={20} color="#c9a26a"/>
                    </div>
                    <div className="flex w-full justify-end items-center">
                        <NotificationIcon count={unReadNotifications} color={notificationColor === "text-sky-600" ? "text-ivory" : notificationColor}/>
                        <MiniAvatar/>

                </div>
                </div>
        }
        <NotificationsDropdown uploadNew={showNotifDropdown} onClose={() => setShowNotifDropdown(false)}/>
        </>
}
export default Header;